import React, { Component } from "react";
import { DetailsGroup } from "./newPurchaseConfirm";
import moment from "moment";
import { Paper } from "@material-ui/core";
import Signbutton from "../../forms/button";
import { EnachModal } from "../customModal";

import { connect } from "react-redux";
import { getEnach } from "../../../store/actions/transactions";
import CustomLoader from "../../forms/Loader";
import { amountInWords } from "../../forms/amount-to-words";
import { pascalCase } from "../../forms/captalize";
import Image from "../../Image";

class EnachConfirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      EnachRef: "",
      EnachOpen: false,
      disabled: false,
    };
  }
  close = () => {
    this.setState({
      EnachOpen: false,
    });
    this.props.history.push("/dashboard");
  };

  submit = async () => {
    this.setState({
      disabled: true,
    });
    const { location } = this.props;
    const { state } = location;
    const {
      Contact,
      Email,
      Name,
      Pan,
      acno,
      bank,
      enddate,
      startdate,
      frequency,
      amount,
      bankName,
    } = state;
    const reformStDT = moment(startdate).format("MM/DD/YYYY");
    const reformEndDT = moment(enddate).format("MM/DD/YYYY");
    const params = {
      Email: Email,
      Contact: Contact,
      Name: Name,
      Pan: Pan,
      invdistflag: "B",
      customfund: "189",
      arncode: this.props.token,
      frequency: frequency,
      acno: acno,
      startdate: reformStDT,
      enddate: reformEndDT,
      txnamount: amount,
      bank_code: bank.split("|")[0],
      BankName: bankName,
      bank_acno: bank.split("|")[2],
      bank_ifsc: bank.split("|")[3],
    };
    console.log(params, "sldfjkd");

    const response = await this.props.getEnach(params);
    if (
      !!response &&
      !!response.DtData &&
      !!response.DtData[0] &&
      !!response.DtData[0].en_ihno
    ) {
      this.setState({
        EnachRef: response.DtData[0].en_ihno,
        EnachOpen: true,
      });
    }
    this.setState({
      disabled: false,
    });
  };

  render() {
    const { location } = this.props;
    const { state } = location;
    const {
      Contact,
      Email,
      Name,
      Pan,
      acno,
      bank,
      enddate,
      startdate,
      frequency,
      amount,
    } = state;
    const { EnachRef, EnachOpen, disabled } = this.state;
    return (
      <React.Fragment>
        <CustomLoader display={!!disabled} />
        <div>
          <Image src={"/images/npci.jpeg"} style={{ height: 60 }} />
        </div>
        <div className="digital-form-main-details-text">
          Summary for ENACH Registration
        </div>
        <Paper className="digital-form-details-paper">
          <DetailsGroup
            mainLabel="Name"
            subLabel={Name}
            mainLabel1="PAN"
            subLabel2={Pan}
          />
          <DetailsGroup
            mainLabel="Email ID"
            subLabel={Email}
            mainLabel1="Mobile"
            subLabel2={Contact}
          />
          <DetailsGroup
            mainLabel="Folio"
            subLabel={acno}
            mainLabel1="Frequency"
            subLabel2={frequency}
          />
          <DetailsGroup
            mainLabel="ENACH Registration Start Date"
            subLabel={moment(startdate).format("DD-MM-YYYY")}
            mainLabel1="ENACH Registration Validity Date"
            subLabel2={moment(enddate).format("DD-MM-YYYY")}
          />
          <DetailsGroup
            mainLabel="Amount"
            subLabel={`₹ ${amount} (Rupees ${pascalCase(
              amountInWords(amount)
            )})`}
            mainLabel1="Bank Account Number"
            subLabel2={bank.split("|")[2]}
          />

          <DetailsGroup
            mainLabel="Authentication Mode"
            subLabel={"Internet Banking"}
          />

          <div
            style={{
              fontFamily: "Rubik-Bold",
              fontSize: 13,
              marginTop: 5,
            }}
          >
            Note:{" "}
            <span style={{ color: "red" }}>
              Your in the process of registration of a E-Mandate. Please submit
              to continue the registration process. In case of any discrepancy
              found in the above mentioned fields you may go back to edit the
              required fields.
            </span>
          </div>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <Signbutton
              buttontitle={"Submit"}
              width={270}
              onClick={this.submit}
            />
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Image
              src={"/images/NACH_logo.png"}
              style={{ height: 60 }}
              alt=""
            />
            <div
              style={{
                fontSize: 18,
                color: "gray",
              }}
            >
              <div>E-MANDATE </div>
              <div>Powered by</div>
            </div>
            <Image src={"/images/NPCI.jpeg"} style={{ height: 60 }} alt="" />
          </div>

          <EnachModal
            message={`You have initiated the eNach successfully with Reference Number : ${EnachRef}`}
            closeYesModal={this.close}
            open={!!EnachOpen}
          />
        </Paper>
      </React.Fragment>
    );
  }
}

export default connect(
  ({ authReducer }) => {
    const { token, userId } = authReducer;
    return { token, userId };
  },
  { getEnach }
)(EnachConfirm);
